import { Grid } from "@mui/material"
import EuropcarCompanySelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Company"
import React from "react"
import EuropcarUserSelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Users"
import EuropcarSiteSelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Sites"
import EuropcarDateRangeFilter from "Pages/BusinessLogistics/Analytics/Page/Filters/DateRange"

export default function EuropcarAnalyticsFilters() {

	return <Grid container spacing={2}>
		<Grid item xs={3}>
			<EuropcarDateRangeFilter/>
		</Grid>
		<Grid item xs={3}>
			<EuropcarCompanySelector/>
		</Grid>
		<Grid item xs={3}>
			<EuropcarUserSelector/>
		</Grid>
		<Grid item xs={3}>
			<EuropcarSiteSelector/>
		</Grid>
	</Grid>
}